import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useBootcamps } from '../../../application/bootcamps/hooks/useBootcamps';
import ToolbarComponent from '../../ui/section';
import DynamicTable from '../../ui/table2';
import Loader from '../../ui/loader';
import { IconButton } from '../../ui/button';
import './style.css';

const BootcampsPage = (props) => {
    const { getBootcamps, isLoading, listColumns, safeId } = useBootcamps();
    const [bootcamps, setBootcamps] = useState([]);

    const goView = useCallback((id) => props.history.push(`/academia/bootcamps/${id}`), [props.history]);
    const goAttendance = useCallback((id) => props.history.push(`/academia/bootcamps/${id}/attendance`), [props.history]);

    const customElements = useMemo(() => ({
        actions: (row) => (
            <div style={{ display: 'flex', gap: 8 }}>
                <IconButton tooltip="Ver estudiantes" onClick={() => goView(safeId(row))}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.58 12C15.58 13.98 13.98 15.58 12 15.58C10.02 15.58 8.42004 13.98 8.42004 12C8.42004 10.02 10.02 8.42004 12 8.42004C13.98 8.42004 15.58 10.02 15.58 12Z" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M12 20.27C15.53 20.27 18.82 18.19 21.11 14.59C22.01 13.18 22.01 10.81 21.11 9.39997C18.82 5.79997 15.53 3.71997 12 3.71997C8.46997 3.71997 5.17997 5.79997 2.88997 9.39997C1.98997 10.81 1.98997 13.18 2.88997 14.59C5.17997 18.19 8.46997 20.27 12 20.27Z" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </IconButton>
                <IconButton tooltip="Crear asistencia" onClick={() => goAttendance(safeId(row))}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.31 14.7L10.81 16.2L14.81 12.2" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M10 6H14C16 6 16 5 16 4C16 2 15 2 14 2H10C9 2 8 2 8 4C8 6 9 6 10 6Z" stroke="#292D32" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M16 4.02002C19.33 4.20002 21 5.43002 21 10V16C21 20 20 22 15 22H9C4 22 3 20 3 16V10C3 5.44002 4.67 4.20002 8 4.02002" stroke="#292D32" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </IconButton>
            </div>
        ),
        tags: (row) => Array.isArray(row?.tags)
            ? row.tags.map((t, i) => <span key={`${t}-${i}`} className="bootcamp-tag">{t}</span>)
            : null
    }), [goAttendance, goView, safeId]);

    useEffect(() => {
        const load = async () => {
            const data = await getBootcamps();
            setBootcamps(Array.isArray(data) ? data : []);
        };
        load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <ToolbarComponent label="Bootcamps" showBackButton={false}>
            <DynamicTable
                headers={listColumns}
                data={bootcamps}
                customElements={customElements}
                fullPage={true}
                showLabel={false}
                loaderComponent={<Loader text="Cargando datos" />}
                isLoading={isLoading}
            />
        </ToolbarComponent>
    );
};

export default BootcampsPage;


